import axios from 'axios';

import store from '../store';
const httpClient = axios.create();
httpClient.defaults.timeout = 5 * 60 * 1000;

const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, POST, DELETE, OPTIONS',
  },
};

const axiosConfig2 = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, POST, DELETE, OPTIONS',
  },
};

const configData = {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token, Authorization',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, POST, DELETE, OPTIONS',
  },
};
class Api {
  POST(url, payload = {}, config = axiosConfig) {
    return httpClient.post(url, payload, config).catch(function (error) {});
  }
  PUT(url, payload = {}, config = axiosConfig) {
    return httpClient.put(url, payload, config).catch(function (error) {});
  }
  AUTHPOST(url, payload = {}, config = axiosConfig2) {
    return httpClient.post(url, payload, config).catch(function (error) {});
  }
  GET(url, config = axiosConfig) {
    return httpClient.get(url, config).catch(function (error) {});
  }
  AUTHGET(url, config = axiosConfig2) {
    return httpClient.get(url, config).catch(function (error) {});
  }
  POSTDATA(url, payload = {}, config = configData) {
    return httpClient.post(url, payload, config).catch(function (error) {});
  }
}
export { httpClient };
export default new Api();
